import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  ApiResponse,
  CreateUpdateSavedPdfDto,
  GetSavedPdfExternalReferralDto,
  GetSavedPdfSignatureStatusDto,
} from '../autogenerated/spdApiClient';

export interface SavedPdfContextInterface {
  getSignatureStatusForReferral: (
    id: string,
  ) => Promise<GetSavedPdfSignatureStatusDto>;
  getSignatureStatusForCard: (
    id: string,
  ) => Promise<GetSavedPdfSignatureStatusDto>;
  savePdfFileForJudgment: (
    attachment: CreateUpdateSavedPdfDto,
  ) => Promise<string>;
  savePdfFileForReferral: (
    attachment: CreateUpdateSavedPdfDto,
  ) => Promise<string>;

  savePdfFileForCard: (attachment: CreateUpdateSavedPdfDto) => Promise<string>;
  getExternalReferralForExamined: (
    examinedId: string,
  ) => Promise<GetSavedPdfExternalReferralDto[]>;
  saveFileInBrowser: (id: string) => Promise<void>;
}

export const SavedPdfContext = (api: DefaultApi) => {
  const handleResponse = async (response: ApiResponse<void>) => {
    const file = await response.raw.blob();
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  return {
    getSignatureStatusForReferral: (id: string) =>
      api.savedPdfControllerGetReferralSignatureStatus(id),
    getSignatureStatusForCard: (id: string) =>
      api.savedPdfControllerGetCardSignatureStatus(id),
    savePdfFileForJudgment: (attachment: CreateUpdateSavedPdfDto) =>
      api.savedPdfControllerSavePdfFileForJudgment(attachment),
    savePdfFileForReferral: (attachment: CreateUpdateSavedPdfDto) =>
      api.savedPdfControllerSavePdfFileForReferral(attachment),
    savePdfFileForCard: (attachment: CreateUpdateSavedPdfDto) =>
      api.savedPdfControllerSavePdfFileForCard(attachment),
    getExternalReferralForExamined: (examinedId: string) =>
      api.savedPdfControllerGetExternalReferralForExamined(examinedId),
    saveFileInBrowser: async (id: string) =>
      api.savedPdfControllerGetFileDownloadRaw({ id }).then(handleResponse),
  };
};
